import React, { PropTypes, Component } from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import classNames from 'classnames'
import moment from 'moment';
import DatePicker from 'react-datepicker';

import Header from '../../../../components/controls/header/Header.jsx';
import Details from '../../../custom/details/Details.jsx';
import Image from '../../../controls/image/Image.jsx';
import ProgressBar from '../../../controls/progressBar/ProgressBar.jsx';

import { routes } from 'pluton-core/lib/constants/routes.constant';
import { ICON_SETTING, IMAGE_LOGO } from 'pluton-core/lib/constants/image.constant';
import { DATEPICKER_FORMAT } from 'pluton-core/lib/constants/data.constant'


class AlertPage extends Component {
    //region lifecycle

    constructor(props) {
        super(props);
        this.state = {
            atTop: false,
            atBottom: false,
        };
    }

    componentDidUpdate(prevProps, prevState) {
        const atTop = this._isAtTop();
        const atBottom = this._isAtBottom();

        if (this.state.atTop != atTop) {
            this.setState({
                atTop
            });
        }

        if (this.state.atBottom != atBottom) {
            this.setState({
                atBottom
            });
        }
    }

    //endregion
    //region methods

    _isNoAlerts = () => {
        return !this.props.details.isLoading &&
            (this.state.atTop || this.state.atBottom);
    };

    _isAtTop = () => {
        if (!this.refs.details || !this.refs.details.refs.scroll) {
            return false;
        }

        const domElement = this.refs.details.refs.scroll.el;
        const delta = 50;
        if (domElement.scrollTop <= delta) {
            return true;
        }

        return false;
    };

    _isAtBottom = () => {
        if (!this.refs.details || !this.refs.details.refs.scroll) {
            return false;
        }

        const domElement = this.refs.details.refs.scroll.el;
        const delta = 50;
        if (domElement.scrollTop + domElement.clientHeight + delta >= domElement.scrollHeight) {
            return true;
        }

        return false;
    };

    handleOnScroll = (event, atTop, atBottom) => {
        if (this.state.atTop && !atTop) {
            this.setState({
                atTop
            });
        }

        if (this.state.atBottom && !atBottom) {
            this.setState({
                atBottom
            });
        }
    };

    handleDatePickerChanged = (e) => {
        const {
            handleDateChange
        } = this.props;

        handleDateChange(e);

        // Because can't clear focus for react-datepicker (there is a lot of timers)
        setTimeout(()=> {
            const node = ReactDOM.findDOMNode(this.refs.datepicker.refs.input);
            node.blur();
        }, 10);
    };

    //endregion
    //region renders

    renderHeader = () => {
        return (
            <Header headerTitle='Alerts'>
                <div className="header__logo header__logo--left">
                    <Image src={IMAGE_LOGO}
                           className="header__icon"
                           imgClassName="icon icon--header"/>
                </div>
                <Link className="header__link header__link--right" to={`${routes.settings()}`}>
                    <Image src={ ICON_SETTING }
                           className="header__icon header__icon--right"
                           imgClassName="icon icon--header"/>
                </Link>
            </Header>
        );
    };

    renderBodyHeader = () => {
        const {
            date,
        } = this.props;

        return (
            <div className="page__top">
                <div className="datepicker">
                    <DatePicker ref="datepicker"
                                readOnly={true}
                                autoFocus={false}
                                dateFormat={DATEPICKER_FORMAT}
                                selected={moment(date)}
                                onChange={this.handleDatePickerChanged}
                                className='datepicker__field'/>
                </div>
                <Link className="link link--arrow">
                    All
                </Link>
            </div>
        );
    };

    renderLogo = () => {
        const {
            details: {
                hasNewItems
            },
            showImportant,
            handleToggleShowImportant
        } = this.props;

        const classNamesObj = classNames({
            'house__img house__img--exclamation': true,
            'house__img--important': showImportant
        });

        let msg = showImportant ? "Important Alerts" : "";
        msg = hasNewItems ? msg : this._isNoAlerts() && "No more notifications";

        const importantView = (
            <div className="sub-title sub-title--important">
                {msg}
            </div>
        );

        return (
            <div ref="logo">
                <div className="page__img">
                    <div className={classNamesObj}
                         onClick={handleToggleShowImportant}>
                    </div>
                </div>
                {importantView}
            </div>
        );
    };

    renderDetails = () => {
        return (
            <Details
                {...this.props}
                ref="details"
                handleOnScroll={this.handleOnScroll}
                style={{height:`10px`}}
            />
        );
    };

    renderLoading = () => {
        if (this.props.isLoading) {
            return (
                <ProgressBar/>
            );
        }

        return null;
    };

    render() {
        return (
            <div className="page">
                {this.renderLoading()}
                {this.renderHeader()}
                <div className="page__content">
                    {this.renderBodyHeader()}
                    {this.renderLogo()}
                    {this.renderDetails()}
                </div>
            </div>
        );
    }
    
    //endregion
}

AlertPage.propTypes = {
    alertModel: PropTypes.func,
    date: PropTypes.object,
    handleDateChange: PropTypes.func,

    details: PropTypes.object,
    handleGetPrev: PropTypes.func,
    handleGetNext: PropTypes.func,

    showImportant: PropTypes.bool,
    handleToggleShowImportant: PropTypes.func,

    alertsToggled: PropTypes.array,
    handleAlertsToggle: PropTypes.func,

    alertReducer: PropTypes.object,
    handleClearAlertToJump: PropTypes.func
};

export default AlertPage;



// WEBPACK FOOTER //
// ./app/components/pages/core/alert/Alert.page.jsx